var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.474,
    height: 16.395,
    viewBox: "0 0 19.474 16.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trip_started",
    d: "M20.819,7.776A1.5,1.5,0,0,0,19.382,6.75H8.092A1.5,1.5,0,0,0,6.655,7.776L4.5,13.421v7.7a1.03,1.03,0,0,0,1.026,1.026H6.553a1.03,1.03,0,0,0,1.026-1.026v-.513H19.9v.513a1.03,1.03,0,0,0,1.026,1.026h1.026a1.03,1.03,0,0,0,1.026-1.026v-7.7ZM8.092,17.527a1.54,1.54,0,1,1,1.54-1.54A1.512,1.512,0,0,1,8.092,17.527Zm11.29,0a1.54,1.54,0,1,1,1.54-1.54A1.512,1.512,0,0,1,19.382,17.527ZM6.553,12.395,8.092,8.29h11.29l1.54,4.105Z",
    transform: "translate(-4 -6.25)",
    fill: "#fff",
    stroke: "#e9944e",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripStarted);
export default __webpack_public_path__ + "static/media/trip_started.c39970903b195163e72ff87e468f44aa.svg";
export { ForwardRef as ReactComponent };